export const MINUTE = 60_000;
export const HOUR = 60 * MINUTE;
export const DAY = 24 * HOUR;
export const TASK_LABELS = [
    'needs-mac',
    'needs-gpu',
    'needs-windows',
    'needs-hardware',
    'needs-user',
    'image-gen',
    'goal-loop',
    'retro',
    'history-triage',
];
export const DEFAULT_CAPS = {
    mac: 4,
    windows: 6,
    linux: 4,
};
export const DEFAULT_AUTONOMY = {
    autoStartRuns: true,
    autoPickMachineAgent: true,
    autoRerouteMachine: true,
    autoSwitchAgent: false,
    saturate: true,
    bulkApprovedWorkstreams: [],
    loopProfile: 'fast',
};
//# sourceMappingURL=types.js.map